export const PRIORITY_FEE_VARIANT_ID = '43646764679234';

export function isPriorityFeeLineItem(item) {
  if (!item) return false;
  const variant = String(
    item.variant_id ?? item.shopify_variant_id ?? item.variantId ?? item.shopifyVariantId ?? ''
  ).replace('gid://shopify/ProductVariant/', '');
  if (variant === PRIORITY_FEE_VARIANT_ID) return true;
  const title = String(item.title ?? item.name ?? '').toLowerCase();
  return title.startsWith('priority time fee');
}

// Before / After / Exact deliveries are meaningless without a clock time. A browser
// time input reads '' until hour, minutes and AM/PM are all filled, so a half-typed
// time silently saves as "Before" with no time (TF20260915-013).
export function isMissingPriorityTime(delivery) {
  if (!delivery || delivery.fulfillmentType === 'pickup') return false;
  return ['before', 'after', 'exact'].includes(delivery.timeCondition) && !delivery.priorityTime;
}

export const MISSING_PRIORITY_TIME_MESSAGE = 'Pick a time for this delivery, or change the time preference';
